import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
} from "@/components/ui/alert-dialog";
import React from "react";

interface BannerDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const BannerDeleteDialog: React.FC<BannerDeleteDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="shadow-lg rounded-xl bg-[linear-gradient(180deg,#092083_0%,#13204B_100%)] p-6 text-white">
        {/*Header*/}
        <AlertDialogHeader>
          <div className="flex justify-between">
            <AlertDialogTitle className="text-2xl font-bold">
              Banner Deletion
            </AlertDialogTitle>
            <button onClick={onClose}>
              <img
                src="/assets/bonus/close-button.png"
                alt="Close Button"
                className="h-6 w-6"
              />
            </button>
          </div>
        </AlertDialogHeader>

        {/*Description*/}
        <AlertDialogDescription className="mt-4 text-center text-lg font-medium text-white">
          Are you sure you want to delete this banner?
          <p className="mt-2 text-center text-sm text-gray-400">
            This deletion cannot be undone
          </p>
        </AlertDialogDescription>

        {/*Footer*/}
        <AlertDialogFooter className="flex justify-center gap-6 pb-4">
          <button
            onClick={onConfirm}
            className="w-full max-w-[200px] rounded-xl bg-gradient-to-r from-[#2861FA] to-[#003DDF] px-10 py-3 text-lg font-medium text-white transition-all hover:from-[#1E4EDF] hover:to-[#002DBB]"
          >
            Yes
          </button>
          <button
            className="w-full max-w-[200px] rounded-xl border border-[#3A3F66] px-10 py-3 text-lg font-medium text-[#A6A9EB] transition-all hover:bg-[#1C2141]"
            onClick={onClose}
          >
            No
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default BannerDeleteDialog;
